module.exports = __webpack_public_path__ + "img/logo-dark.82971d1b.svg";